import { createSlice } from '@reduxjs/toolkit';
import { fetchReconfirmationOrder } from './actions';

const initialState = {
  data: {},
  page: 1,
  status: 'idle', //'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

export const reconfirmationOrder = createSlice({
  name: 'reconfirmationOrder',
  initialState,
  reducers: {
    // reducers goes here
    saveVehicleData: (state, action) => {
      return { ...state, vehicleList: action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReconfirmationOrder.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchReconfirmationOrder.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(fetchReconfirmationOrder.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      });
  },
});

export const { saveVehicleData } = reconfirmationOrder.actions;

export default reconfirmationOrder.reducer;
